import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "@/data/content";
import { useBooking } from "@/booking";

export const Services = () => {
  const openBooking = useBooking();

  return (
    <section id="services" data-testid="services-section" className="bg-cream-dark py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal className="mb-14 max-w-2xl">
          <Overline>Services</Overline>
          <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            How I Can Help You
          </h2>
          <p className="mt-4 text-base leading-relaxed text-ink-muted sm:text-lg">
            Mentoring and learning experiences designed to help you understand your patterns, build practical
            systems, and move forward with clarity.
          </p>
        </Reveal>

        <div className="grid gap-5 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.num} delay={(i % 2) * 0.1}>
              <div
                data-testid={`service-card-${i}`}
                className={`group relative flex h-full flex-col overflow-hidden rounded-[2rem] p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 sm:p-10 ${
                  s.highlight
                    ? "bg-night text-cream shadow-[0_30px_60px_-25px_rgba(42,23,20,0.6)]"
                    : "border border-peach/20 bg-white hover:border-peach-dark/40 hover:shadow-[0_24px_50px_-24px_rgba(226,121,111,0.45)]"
                }`}
              >
                <span
                  aria-hidden
                  className={`pointer-events-none absolute -right-3 -top-7 select-none font-display text-[7rem] leading-none ${
                    s.highlight ? "text-peach/15" : "text-peach/20"
                  }`}
                >
                  {s.num}
                </span>
                <h3 className={`relative font-heading text-xl font-bold sm:text-2xl ${s.highlight ? "text-cream" : "text-ink"}`}>
                  {s.title}
                </h3>
                <p className={`relative mt-4 flex-1 text-sm leading-relaxed sm:text-base ${s.highlight ? "text-cream/75" : "text-ink-muted"}`}>
                  {s.text}
                </p>
                <button
                  data-testid={`service-cta-${i}`}
                  onClick={openBooking}
                  className={`relative mt-8 inline-flex w-fit items-center gap-1.5 rounded-full px-6 py-3 font-heading text-[13px] font-bold transition-[background-color,color,transform] duration-300 hover:-translate-y-0.5 ${
                    s.highlight
                      ? "bg-peach-dark text-cream hover:bg-peach-deeper"
                      : "border border-ink/15 text-ink hover:border-peach-dark hover:bg-cream-dark"
                  }`}
                >
                  {s.cta}
                  <ArrowUpRight size={15} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
